// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

export const CoaTypeEnum = Object.freeze({
  ACCOUNT: 'ACCOUNT',
  BALANCE_ADJUSTMENT: 'BALANCE_ADJUSTMENT',
  CATEGORY: 'CATEGORY',
  UNCATEGORIZED: 'UNCATEGORIZED',
  NONE: 'NONE',
});
export type CoaType = $Values<typeof CoaTypeEnum>; // eslint-disable-line no-undef

export const BalanceAdjustmentTypeEnum = Object.freeze({
  BALANCE_ADJUSTMENT: '0',
  OPENING_BALANCE: '1',
  TRANSFER: '2',
  CREDIT_CARD_PAYMENT: '3',
});
export type BalanceAdjustmentType = $Values<typeof BalanceAdjustmentTypeEnum>; // eslint-disable-line no-undef

type ChartOfAccountProps = {
  type: CoaType,
  id: string,
};
export type ChartOfAccount = RecordOf<ChartOfAccountProps>;
export const mkChartOfAccount: RecordFactory<ChartOfAccountProps> =
  Record({
    type: CoaTypeEnum.UNCATEGORIZED,
    id: '0',
  });

export const ChartOfAccountNode = Record({
  id: null,
  coa: null,

  name: null,
  fullPathName: null,

  path: null,
  children: null,

  inList: true,
});
